<template>
  <b-input-group class="group-social-networks">
    <b-form-input
      class="mt-1"
      v-model="rede_social_value"
      @blur="checkSocialNetwork()"
      @focus="focus()"
      :state="validateState('value')"
      :size="size"
    ></b-form-input>
    <b-input-group-append class="mt-1" :size="size">
      <b-dropdown no-caret dropleft split-variant="outline-primary">
        <template #button-content>
          <div
            class="social-button"
            :class="
              (rede_social.rede_social ? rede_social.rede_social : 'select') +
              '-icon'
            "
          >
            <label class="active" />
          </div>
        </template>

        <div class="text-nowrap">
          <b-form-radio
            v-for="(value, key) in redes_sociais"
            :key="key"
            v-model="rede_social.rede_social"
            :value="value"
            :class="value + '-icon'"
            class="social-button"
            button
            :size="size"
          />
        </div>
      </b-dropdown>
      <b-button
        v-b-tooltip.hover
        title="Remover campo rede social"
        variant="danger"
        @click="remove()"
        class="btn-remove-contato"
        :size="size"
      >
        <font-awesome-icon icon="trash" />
      </b-button>
    </b-input-group-append>
    <b-form-invalid-feedback> URL inválida </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

import { validationMixin } from "vuelidate";
import { url } from "vuelidate/lib/validators";

export default {
  mixins: [formControlMixin, formStateMixin, validationMixin],
  props: makePropsConfigurable(
    sortKeys({
      ...formStateProps,
      ...formControlProps,
      value: {},
      size: {
        type: String,
        default: "",
      },
    })
  ),
  data: () => ({
    rede_social: {},
  }),
  computed: {
    rede_social_value: {
      set(value) {
        this.rede_social.value = value;
      },
      get() {
        return this.rede_social.value;
      },
    },
    redes_sociais() {
      return ["linkedin", "facebook", "instagram", "twitter", "link"];
    },
  },
  validations: {
    rede_social: {
      value: { url },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.rede_social[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.rede_social.$touch();
      return !this.$v.rede_social.$anyError;
    },
    remove() {
      this.$emit("remove");
    },
    checkSocialNetwork() {
      if (this.value.value == "http://" || this.value.value == "https://") {
        this.value.value = "";
      }

      this.redes_sociais.forEach((rede_social) => {
        if (this.rede_social_value.indexOf(rede_social + ".com") > -1) {
          this.rede_social.rede_social = rede_social;
        }
      });
    },
    focus() {
      if (
        this.value.value.indexOf("http://") != 0 &&
        this.value.value.indexOf("https://") != 0
      ) {
        this.value.value = "https://" + this.value.value;
      }
    },
  },
  watch: {
    value: function (value) {
      this.rede_social = value;
    },
  },
  async created() {
    this.rede_social = this.value;
  },
};
</script>

<style></style>
